import { render, staticRenderFns } from "./file.pug?vue&type=template&id=0bdf9006&lang=pug&"
import script from "./file.js?vue&type=script&lang=js&"
export * from "./file.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lauramunozruiz/multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bdf9006')) {
      api.createRecord('0bdf9006', component.options)
    } else {
      api.reload('0bdf9006', component.options)
    }
    module.hot.accept("./file.pug?vue&type=template&id=0bdf9006&lang=pug&", function () {
      api.rerender('0bdf9006', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input/modules/fileImg/index.vue"
export default component.exports